import { useState } from "react";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../function/helper";
import useSharedData from "../../../../hooks/useSharedData";
import StreamingPDFButton from "./StreamingPDFButton";

function Info() {
  const { user } = useSharedData();

  const [myInfo, setMyInfo] = useState({
    firstName: user.name,
    lastName: user.family,
  });
  const [btnLoading, setBtnLoading] = useState(false);

  const updateInfo = async () => {
    const body = { name: myInfo.firstName, family: myInfo.lastName };
    const response = await postRequestByAuth("/user/v1/updateuser", body);
    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.data,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
        customClass: "rtl-all",
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.data,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
        customClass: "rtl-all",
      });
    }
  };

  const [myPass, setMyPass] = useState({
    oldPass: "",
    newPass: "",
    repeatPass: "",
  });

  const [errorsMyPass, setErrorsMyPass] = useState({});

  const findMyPassErrors = () => {
    const { oldPass, newPass, repeatPass } = myPass;
    const newErrors = {};
    if (!oldPass || oldPass === "") {
      newErrors.oldPass = "رمز فعلی الزامی است";
    }
    if (!newPass || newPass === "") {
      newErrors.newPass = "رمز جدید الزامی است";
    }
    if (!repeatPass || repeatPass === "") {
      newErrors.repeatPass = "تکرار رمز الزامی است";
    }
    return newErrors;
  };

  const submitMyPass = e => {
    e.preventDefault();
    const newErrors = findMyPassErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrorsMyPass(newErrors);
    } else {
      changepass();
    }
  };

  const setFormMyPass = (field, value) => {
    setMyPass({ ...myPass, [field]: value });
    if (errorsMyPass[field])
      setErrorsMyPass({ ...errorsMyPass, [field]: null });
  };

  const changepass = async () => {
    const body = {
      oldPass: myPass.oldPass,
      newPass: myPass.newPass,
      repeatPass: myPass.repeatPass,
    };
    setBtnLoading(true);
    const response = await postRequestByAuth("/user/v1/updatpassword", body);
    setBtnLoading(false);

    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.data,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
        customClass: "rtl-all",
      });
      setMyPass({ oldPass: "", newPass: "", repeatPass: "" });
      localStorage.setItem("token", response.data.token);
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.data,
        sshowConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
        customClass: "rtl-all",
      });
    }
  };

  const findMyInfoErrors = () => {
    const { firstName, lastName } = myInfo;
    const newErrors = {};
    if (!firstName || firstName === "") {
      newErrors.firstName = "نام الزامی است";
    }
    if (!lastName || lastName === "") {
      newErrors.lastName = "نام خانوادگی الزامی است";
    }
    return newErrors;
  };

  const [errorsMyInfo, setErrorsMyInfo] = useState({});

  const setFormMyInfo = (field, value) => {
    setMyInfo({ ...myInfo, [field]: value });
    if (errorsMyInfo[field])
      setErrorsMyInfo({ ...errorsMyInfo, [field]: null });
  };

  const submitMyInfo = e => {
    e.preventDefault();
    const newErrors = findMyInfoErrors();

    if (Object.keys(newErrors).length > 0) {
      setErrorsMyInfo(newErrors);
    } else {
      updateInfo();
    }
  };

  return (
    <div>
      <h5 className="text-secondary">اطلاعات شخصی</h5>
      <hr className="" height="4" color="info" />
      <div className="p-3 m-1">
        <Form onSubmit={submitMyInfo}>
          <Form.Group>
            <Form.Label> نام:</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              value={myInfo.firstName}
              onChange={e => {
                setFormMyInfo("firstName", e.target.value);
              }}
              isInvalid={!!errorsMyInfo.firstName}
            />
            <Form.Control.Feedback type="invalid">
              {errorsMyInfo.firstName}
            </Form.Control.Feedback>
            <Form.Label> نام خانوادگی:</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              value={myInfo.lastName}
              onChange={e => {
                setFormMyInfo("lastName", e.target.value);
              }}
            />
            <Form.Control.Feedback type="invalid">
              {errorsMyInfo.lastName}
            </Form.Control.Feedback>
            <Form.Label> شماره تلفن:</Form.Label>
            <Form.Control
              type="text"
              name="mobile"
              disabled={true}
              title="برای تغییر شماره موبایل با پشتیبانی تماس بگیرید"
              value={user.phone}
              readOnly
            />
          </Form.Group>
          <div className="d-flex align-items-center justify-content-center">
            <button type="submit" className="btn-success-style my-5 px-5">
              ثبت
            </button>
          </div>
        </Form>
      </div>

      <h5 className="text-secondary">تغییر کلمه عبور</h5>
      <hr className="" height="4" color="info" />
      <div className="p-3 m-1">
        <Form onSubmit={submitMyPass}>
          <Form.Group>
            <Form.Label>
              رمز فعلی:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="oldPass"
              autoComplete="new-password"
              value={myPass.oldPass}
              onChange={e => {
                setFormMyPass("oldPass", e.target.value);
              }}
              isInvalid={!!errorsMyPass.oldPass}
            />
            <Form.Control.Feedback type="invalid">
              {errorsMyPass.oldPass}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              رمز جدید:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              name="newPass"
              autoComplete="new-password"
              value={myPass.newPass}
              onChange={e => {
                setFormMyPass("newPass", e.target.value);
              }}
              isInvalid={!!errorsMyPass.newPass}
            />
            <Form.Control.Feedback type="invalid">
              {errorsMyPass.newPass}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              تکرار رمز جدید:
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              autoComplete="new-password"
              name="repeatPass"
              value={myPass.repeatPass}
              onChange={e => {
                setFormMyPass("repeatPass", e.target.value);
              }}
              isInvalid={!!errorsMyPass.repeatPass}
            />
            <Form.Control.Feedback type="invalid">
              {errorsMyPass.repeatPass}
            </Form.Control.Feedback>
          </Form.Group>
          <div className="d-flex align-items-center justify-content-center">
            {btnLoading && (
              <LoadingButton
                className="bg-avaex text-white my-5 px-3"
                title="در حال ثبت"
              />
            )}
            {btnLoading === false && (
              <button type="submit" className="btn-success-style my-5 px-5">
                ثبت
              </button>
            )}
          </div>
        </Form>
      </div>

      <StreamingPDFButton />
    </div>
  );
}

export default Info;
